import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

export default function FAQAccordion({ faqs }) {
  const [active, setActive] = useState(0);
  return (
    <div className="grid gap-3">
      {faqs.map((faq, index) => (
        <div key={faq.question} className="rounded-xl border border-line bg-white shadow-sm">
          <button className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-semibold text-dark" onClick={() => setActive(active === index ? -1 : index)} aria-expanded={active === index}>
            {faq.question}
            <FaChevronDown className={`shrink-0 text-primary transition ${active === index ? "rotate-180" : ""}`} />
          </button>
          {active === index && <p className="border-t border-line px-5 py-4 leading-7 text-body">{faq.answer}</p>}
        </div>
      ))}
    </div>
  );
}
